import Config from '@config';
import { extendWithRoles } from '@gasbi/shared/common/features/roles';
import { normalizeInfiniteQueryData } from '@gasbi/shared/common/features/utils';

import { householdsApi } from '@/app/householdsApi';

/**
 * The organization roles of Households Billing's shared RBAC (`/api/organizations/...`, GSB-8308): the roles its
 * permissions come from. Injected into householdsApi, whose slices name their base per endpoint; these endpoints
 * have none, so the prefix is absolute and the http instance's own base does not apply.
 */
export const organizationRolesApi = extendWithRoles(
  householdsApi as never,
  `${window.location.origin}${Config.VITE_API_URL}/organizations`,
);

export const useGetOrganizationRolesInfiniteQuery = normalizeInfiniteQueryData(
  organizationRolesApi.useGetOrganizationRolesInfiniteQuery,
);
